<template>
  <div class="cus-chat-supervise" v-loading="loading">
    <div class="cus-chat-supervise-search">
      <el-form :inline="true" class="form-row">
        <el-form-item label="任务名称">
          <el-input v-model="formInline.msgName" size="mini" clearable @change="selectBindStatus" />
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始时间"
            end-placeholder="结束时间" size="mini" @change="selectBindStatus" :picker-options="pickerOptions" />
        </el-form-item>
      </el-form>
      <el-button type="primary" size="mini" @click="openPopup('add')">新建任务</el-button>
    </div>

    <div class="table-row" ref="tableWrapper">
      <el-table size="small" :data="tableData" fit highlight-current-row align="center"
        :header-cell-style="{ background: '#eef1f6' }" ref="cusChatTable" @selection-change="handleSelectionChange"
        :height="tableHeight">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ getGlobalIndex(scope.$index) }}
          </template>
        </el-table-column>
        <el-table-column prop="msgName" label="任务名称" show-overflow-tooltip align="center">
        </el-table-column>
        <el-table-column prop="content" label="发送内容" align="center">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.content" placement="top"
              :disabled="!showTooltip(scope.row.content)">
              <div class="content-cell" ref="contentCell" @mouseover="handleMouseOver(scope.$index)">
                {{ scope.row.content }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="executeNum" label="执行群聊数" align="center">
        </el-table-column>
        <el-table-column prop="finishNum" label="完成数" align="center">
        </el-table-column>
        <el-table-column prop="unexecuteNum" label="未完成数" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建人/时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.createByName + '/' + scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" align="center" v-if="isShow" width="260">
          <template slot-scope="scope">
            <div style="display: flex;
          justify-content: flex-end;">
              <el-button type="primary" v-if="scope.row.pushType != 0" link size="mini"
                @click="openPopup('edit', scope.row)">编辑</el-button>
              <el-button type="primary" v-else link size="mini" @click="openPopup('details', scope.row)">详情</el-button>
              <el-button type="primary" link size="mini" @click="runRes(scope.row)">执行结果</el-button>
              <el-button type="danger" link size="mini" @click="deleteRow(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="Pagination-row">
      <el-pagination @current-change="changePage" @size-change="changeSize" :current-page.sync="formInline.page"
        :page-size.sync="formInline.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
        :page-sizes="[20, 50, 100, 200, 500]">
      </el-pagination>
    </div>
    <!-- <Pagination class="Pagination-row" v-bind:childMsg="pageparm" :pageSizes="pageSizes" @callBack="callBack">
    </Pagination> -->
    <addEditPopup v-if="showAddEditPopup" :row="rowPopup" :dialogVisible.sync="showAddEditPopup" :myType="7"
      :currentPopupType="currentPopupType" @getData="selectBindStatus" :titleName="popupTitle" />
    <executionResPopup v-if="showExecutionResPopup" :dialogVisible.sync="showExecutionResPopup" :row="rowPopup"
      @openViewPopup="openViewPopup" />
    <viewChatHistory v-if="showViewChatHistory" :dialogVisibleV.sync="showViewChatHistory" :row="currentRow" />
  </div>
</template>
<script>
import addEditPopup from './addEditPopup.vue'
import executionResPopup from './executionResPopup.vue'
import viewChatHistory from './viewChatHistory.vue'
import {
  getMsgGroupSendListApi,
  removeSendMsgApi,
} from "@/api/groupSop.js";
import dayjs from "dayjs";
export default {
  name: "groupSop",
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    addEditPopup, executionResPopup, viewChatHistory
  },
  data() {
    return {
      popupTitle: '',
      rowPopup: null,
      currentRow: null,
      showViewChatHistory: false,
      showAddEditPopup: false,
      showExecutionResPopup: false,
      tableData: [],
      tableHeight: 500,
      dialogVisible: false,
      uid: "",
      chatTitle: "",
      options: [
        {
          bindStatus: 10,
          label: "不限",
        },
        {
          bindStatus: 1,
          label: "已绑定档案",
        },
        {
          bindStatus: 0,
          label: "未绑定档案",
        },
      ],
      total: 0,

      formInline: {
        page: 1,
        size: 20,
        msgName: "",
        tagId: [],
        startTime: "",
        endTime: "",
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      date: null,
      tagList: [],
      tagVisible: false,
      currentTagId: "",
      tagProps: {
        multiple: true, //是否允许多选
        label: "tagName",
        value: "tagId",
        children: "groupChatTagDetailDtoList",
        showAllLevels: false,
        // checkStrictly: true
        // checkStrictly: true
        // emitPath: false
      },
      addTagItem: [],
      handleTag: false, //打标签是否可见
      handleChat: false, //聊天记录是否可见
      handleDta: false, //可同步数据是否可见
      /** 是否新版本会话 true新版 false旧版*/
      isNewEdition: true,
      // 提示实例，防止弹出多个提示
      messageInstance: null,
      // 控制
      newEditionDialogVisible: false,
      loading: false,
      currentPopupType: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 当前时间减一天，确保可以选择今天
        }
      },
      tooltipStatus: {} // 存储每行的提示状态
    };
  },
  computed: {
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 动态计算父容器高度
      this.tableHeight = this.$refs.tableWrapper.clientHeight;
    });
    this.getList();
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    btnAuthority: {
      handler(newVal, oldVal) {
        console.log("XXXXXXXX", newVal);
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "群列表") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("qglkdbq") != -1) {
                // 可打标签
                this.handleTag = true;
              } else {
                this.handleTag = false;
              }
              if (senBtnAuthority.indexOf("qglkckltjl") != -1) {
                // 可查询聊天记录
                this.handleChat = true;
              } else {
                this.handleChat = false;
              }
              if (senBtnAuthority.indexOf("qglktbsj") != -1) {
                // 可同步数据按钮
                this.handleDta = true;
              } else {
                this.handleDta = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    /**页码改变 */
    changePage(val) {
      this.formInline.page = val
      this.getList()
    },
    /**页大小改变 */
    changeSize(val) {
      this.formInline.page = 1
      this.formInline.size = val
      this.getList()
    },
    handleResize() {
      const element = this.$refs.tableWrapper;
      if (element) {
        this.tableHeight = element.clientHeight;
      }
    },
    // 检查是否需要显示tooltip
    showTooltip(content) {
      return content && content.length > 60; // 根据实际内容长度调整
    },

    // 鼠标悬停处理
    handleMouseOver(index) {
      this.$set(this.tooltipStatus, index, true);
    },
    getGlobalIndex(index) {
      return (this.formInline.page - 1) * this.formInline.size + index + 1;
    },
    /**查看聊天记录 */
    openViewPopup(row) {
      this.currentRow = row
      this.showViewChatHistory = true
    },
    /**新建  编辑 详情*/
    openPopup(val, row) {
      this.currentPopupType = val
      console.log('openPopup', val, row);
      switch (val) {
        case 'add':
          this.popupTitle = '新建任务'
          this.rowPopup = null
          break;
        case 'edit':
          this.rowPopup = row
          this.popupTitle = '编辑任务'
          break;
        case 'details':
          this.rowPopup = row
          this.popupTitle = '查看'
          break;

        default:
          break;
      }

      this.showAddEditPopup = true
    },
    /**执行结果 */
    runRes(row) {
      console.log('runRes', row);
      this.rowPopup = row
      this.showExecutionResPopup = true
    },
    /**删除 */
    deleteRow(row) {
      console.log('deleteRow', row);
      this.$confirm(`是否确定删除“${row.msgName}”`, '提示', {
        confirmButtonText: '确定',
        type: "warning",
      }).then(() => {
        this.loading = true
        removeSendMsgApi({ id: row.id }, localStorage.getItem("Authorization")).then(
          (res) => {
            this.loading = false
            if (res.error.code == 200) {
              this.$message.success("删除成功!");
              this.getList();
            }
          }
        );
      }).catch(() => {
        this.loading = false
      });


    },
    handleSelectionChange(val) {
      console.log(val);
      this.$emit('subGroup', val)
    },
    selectBindStatus() {
      this.formInline.page = 1;
      if (this.date != null) {
        this.formInline.startTime = dayjs(this.date[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formInline.endTime =
          dayjs(this.date[1]).format("YYYY-MM-DD") + " " + "23:59:59";
      } else {
        this.formInline.startTime = "";
        this.formInline.endTime = "";
      }
      this.getList();
    },
    selectTime() {
      this.formInline.page = 1;
      this.getList();
    },
    onInputBlur() {
      this.formInline.page = 1;
      this.getList();
    },
    /**获取数据 */
    getList() {
      this.loading = true
      getMsgGroupSendListApi(this.formInline, localStorage.getItem("Authorization")).then((res) => {
        this.loading = false
        if (res.error.code == 200) {
          if (res.data.records.length > 0) {
            this.tableData = res.data.records;
            this.total = Number(res.data.total || 0);
          } else {
            this.tableData = [];
            this.total = 0
          }
        }
      }).catch(() => {
        this.loading = false
      });
    },

    search() {
      this.formInline.page = 1;
      this.getList();
    },

    clear() {
      this.formInline.name = "";
    },

    test(index, row) {
      console.log(row);
      this.uid = row.chatId;
      this.dialogVisible = true;
      this.chatTitle = row.msgName;
    },
    callBack(parm, type) {
      this.formInline.page = parm.currentPage;
      this.formInline.size = type == 1 ? parm.pageSize : parm.size;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.cus-chat-supervise {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;

  .cus-chat-supervise-search {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .form-row {
      height: 100%;
    }
  }

  .table-row {
    flex: 1;
    overflow: hidden;
  }

  .Pagination-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }

  .el-dialog {
    min-width: 620px;
    max-width: 1200px;
  }

  .el-dialog__title {
    line-height: 24px;
    font-size: 16px;
    font-weight: bold;
    color: #0f0f0f;
  }

  .el-dialog__body {
    padding: 5px 30px 20px !important;
  }
}

.content-cell {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  /* 可以设置行高，确保三行高度固定 */
  line-height: 20px;
  max-height: 60px;
  /* 3 * 20px */
}
</style>
